import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

import { useUser } from '@reverbdotcom/commons/src/user_hooks';

import {
  buildSellingSection,
  buildBuyingSection,
  buildFinancesSection,
  buildMyAccountSection,
  buildExploreSection,
  buildJoinReverbSection,
  ILinkProps,
} from './reverb_header_menu_data';
import ReverbHeaderMenuSection from './reverb_header_menu_section';
import { ReverbHeaderUserMenuData } from '../../../schemas/rql';

interface IProps {
  me: ReverbHeaderUserMenuData.Fragment;
}

const DEFAULT_AVATAR = 'https://reverb-dev-res.cloudinary.com/image/upload/s--BtEvm2y3--/v1546540852/default--rounded_misa1r.png';

interface IMobileMenuSectionProps {
  data: {
    key: string;
    title: string;
    links: ILinkProps[]
  }
}

export function MobileMenuSection({ data }: IMobileMenuSectionProps) {
  const { key, title, links } = data;

  return (
    <ReverbHeaderMenuSection key={key} title={title} links={links} />
  );
}

function ReverbHeaderMobileMenu({ me }: IProps) {
  const user = useUser();
  const [open, setOpen] = React.useState(false);
  const classes = classNames(
    'reverb-header__mobile-menu',
    { 'reverb-header__mobile-menu--active': open },
  );

  const avatar = user.avatarUrl || DEFAULT_AVATAR;
  const { slug: shopSlug, paymentMethod: shopPaymentMethod } = me?.shop || {};

  const signedIn = !user.loggedOut;

  return (
    <>
      <li className="reverb-header__show-only-on-mobile">
        <button
          type="button"
          className="reverb-header__mobile-menu-toggle"
          onClick={() => setOpen(true)}
        >
          {I18n.t('discovery.reverbHeader.mobileMenu.badge')}
        </button>
      </li>
      <div className={classes}>
        <button
          type="button"
          className="reverb-header__mobile-menu__close"
          onClick={() => setOpen(false)}
        >
          {I18n.t('discovery.reverbHeader.mobileMenu.close')}
        </button>
        <div className="reverb-header__mobile-menu__header reverb-header__mobile-menu__header--centered">
          {signedIn && (
            <>
              <div className="reverb-header__avatar" title={user.name}>
                <img width="64" height="64" src={avatar} alt="Avatar" />
              </div>
              <div className="reverb-header__name reverb-header__name--mobile" title={user.name}>
                {user.name}
              </div>
            </>
          )}
        </div>
        <div className="g-container">
          <div className="g-col-6">
            <MobileMenuSection data={buildExploreSection(user)} />
            {signedIn && (
              <>
                <MobileMenuSection data={buildBuyingSection()} />
                <MobileMenuSection data={buildMyAccountSection({ locale: user.locale })} />
              </>
            )}
          </div>
          <div className="g-col-6">
            {user.loggedOut && <MobileMenuSection data={buildJoinReverbSection(user.locale)} />}
            {signedIn && <MobileMenuSection data={buildSellingSection(shopSlug)} />}
            {shopPaymentMethod && <MobileMenuSection data={buildFinancesSection(shopPaymentMethod)} />}
          </div>
        </div>
      </div>
    </>
  );
}

export default ReverbHeaderMobileMenu;
